import React from "react";
import Card from "../../../../componets/Card";
import { AddonInterface } from "../../../../store/mine_craft/addonsSlice";

const _Details = ({ addon }: { addon: AddonInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {addon?.search_text}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body Content</h4>
        {addon?.description}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body HTML</h4>

        <iframe className='v-content-html' title='Description HTML' srcDoc={addon?.description_html} />
      </Card>
    </>
  );
}

export default _Details;
